import { render, staticRenderFns } from "./ymYou.vue?vue&type=template&id=5683619e&"
import script from "./ymYou.vue?vue&type=script&lang=js&"
export * from "./ymYou.vue?vue&type=script&lang=js&"
import style0 from "./ymYou.vue?vue&type=style&index=0&id=5683619e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports